import { UserManager } from 'oidc-client';

const config = {
  applicationName: 'Signature.Helm.WebUi'
};

const authenticationService = (function () {
  let user;
  let userManager;

  const init = async () => {
    if (userManager !== undefined) {
      return;
    };

    const response = await fetch(`/api/oidcconfiguration/${config.applicationName}`);
    const settings = await response.json();

    userManager = new UserManager(settings);
  };

  const createArgs = (state) => {
    return {
      useReplaceToNavigate: true,
      data: state
    };
  };

  const success = (state) => {
    return {
      status: 'success',
      state
    };
  };

  const error = (message) => {
    return {
      status: 'error',
      message
    };
  };

  const getUser = async () => {
    await init();

    if (user && user.profile) {
      return user.profile;
    };

    user = await userManager.getUser();
    
    return user;
  };

  const isAuthenticated = async () => {
    const user = await getUser();

    return !!user;
  };

  const signIn = async (state) => {
    await init();

    await userManager.signinRedirect(createArgs(state));
  };

  const signInCallback = async (url) => {
    try {
      await init();
      user = await userManager.signinCallback(url);

      return success(user && user.state);
    } catch (e) {
      return error(e.message);
    };
  };

  const signOut = async (state) => {
    await init();

    await userManager.signoutRedirect(createArgs(state));
  };

  const signOutCallback = async (url) => {
    try {
      await init();
      const response = await userManager.signoutCallback(url);
      user = null;

      return success(response && response.state);
    } catch (e) {
      return error(e.message);
    };  
  };

  return {
    getUser,
    isAuthenticated,
    signIn,
    signInCallback,
    signOut,
    signOutCallback
  };
})();

export default authenticationService;